module.exports = __webpack_public_path__ + "img/pic4.922fd5d7.png";